import React from 'react';
import PropTypes from 'prop-types';
import './SupersearchHighlight.scss';

const escapeRegex = text => {
	return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

export const isMatch = (text, searchStr) => {
	if (text && searchStr) {
		const escapedText = escapeRegex(searchStr.toString());
		const reg = new RegExp(escapedText, 'gi');
		const matches = text.toString().match(reg);
		return !!(matches && matches.length);
	} else {
		return false;
	}
};

const diacritic = text => {
	return text
		.split('')
		.map(function (char) {
			if ('aâàáåä'.indexOf(char) > -1) {
				return '[aâàáåä]';
			}
			if ('eêëèé'.indexOf(char) > -1) {
				return '[eêëèé]';
			}
			if ('[iîïìí]'.indexOf(char) > -1) {
				return '[iîïìí]';
			}
			if ('[oôòóö]'.indexOf(char) > -1) {
				return '[oôòóö]';
			}
			if ('uûüùú'.indexOf(char) > -1) {
				return '[uûüùú]';
			}
			if ('[wŵẅẁẃ]'.indexOf(char) > -1) {
				return '[wŵẅẁẃ]';
			}
			if ('[yŷÿỳý]'.indexOf(char) > -1) {
				return '[yŷÿỳý]';
			}
			return char;
		})
		.join('');
};

const getRegExp = (value, type) => {
	let reg;
	let escapedText = escapeRegex(value.toString());
	// Divide in words and sort by length to match the longest word first
	const words = value
		.toString()
		.split(' ')
		.sort((a, b) => b.length - a.length)
		.map(w => escapeRegex(w));
	if (type === 'email' && value[0] !== '@') {
		escapedText = diacritic(escapedText);
		reg = new RegExp('(^|\\.|\\-|@)' + escapedText, 'gi');
	} else if (type === 'phone' && /[0-9 -+()]{5,}/.test(escapedText)) {
		const phoneRegexp =
			escapedText
				.split('')
				.filter(function (char) {
					return char >= '0' && char <= '9';
				})
				.map(function (char) {
					return '.*' + char;
				})
				.join('') + '.*';

		reg = new RegExp(phoneRegexp, 'gi');
	} else if (type === 'string') {
		const escapedStr = '(' + words.map(w => diacritic(w)).join('|') + ')';
		reg = new RegExp(escapedStr, 'gi');
	} else {
		const escapedStr = '(' + words.join('|') + ')';
		reg = new RegExp(escapedStr, 'gi');
	}
	return reg;
};

const SupersearchHighlight = ({ searchStr, text, type }) => {
	if (!searchStr) {
		return text;
	}

	if (!text) {
		return null;
	}
	const reg = getRegExp(searchStr.toString().trim(), type);
	const segments = text.replace(reg, '#jump').split('#jump');
	const matches = text.match(reg);

	const res = segments.reduce((res, segment, i) => {
		const nextMatch = matches?.shift();
		if (segment !== '@') {
			res.push(<span key={'nomatch-' + i}>{segment}</span>);
		}
		if (nextMatch && nextMatch.length) {
			res.push(
				<span key={'match-' + i} className="SupersearchHighlight__match">
					<span>{nextMatch}</span>
				</span>
			);
		}
		return res;
	}, []);

	return <span className="SupersearchHighlight">{res}</span>;
};

SupersearchHighlight.propTypes = {
	searchStr: PropTypes.string,
	text: PropTypes.string.isRequired,
	type: PropTypes.oneOf(['email', 'string', 'phone'])
};

export default SupersearchHighlight;
